import React from 'react';
import { database } from '../../firebaseConfig'
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { addDoc, collection, deleteDoc, doc, onSnapshot, query } from 'firebase/firestore';
import AdminDashboard from "../../UserPanel/Shared/AdminDashboard/AdminDashboard";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./ProjectPhotos.css"

const ProjectPhotos = (props) => {
    const [projects, setProjects] = useState([]);
    const { id } = useParams();

    // useEffect(() => {
    //     fetch(`https://firestore.googleapis.com/v1/projects/database-adminlogin/databases/(default)/documents/ourProjects/${id}/projectGallery`)
    //         .then((res) => res.json())
    //         .then((data) => setProjects(data));
    // }, [id])
    useEffect(() => {

        //create the query
        const q = query(collection(database, `ourProjects/${id}/projectGallery`))
        //create listener
        const portfolioListenerSubscription = onSnapshot(q, (querySnapShot) => {
            const list = []
            querySnapShot.forEach((doc) => {
                list.push({ ...doc.data(), id: doc.id })
            })
            setProjects(list)

        })
        return portfolioListenerSubscription;
    }, [id])

    console.log(projects)
    const collectionRef = collection(database, `ourProjects/${id}/projectGallery`);
    const [image, setImage] = useState('');


    const handleSubmit = () => {
        if (image) {
            addDoc(collectionRef, {
                images: image

            }).then(() => {
                document.getElementById('image').value = '';
                alert('image is uploaded')
            }).catch((error) => {
                alert(error.message);

            })
        }
        else {
            alert("no Image Found")
        }


    }

    const handleDelete = (deleteid) => {

        console.log(deleteid);
        deleteDoc(doc(database, `ourProjects/${id}/projectGallery`, deleteid)).then(() => {
            alert("image deleted")
        })


    }

    const convert2base64 = e => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result.toString());
        }
        reader.readAsDataURL(file);
    }


    return (
        <div className='galleryBack'>
            <div><AdminDashboard></AdminDashboard></div>
            <div className="mt-5 submitBox container ">

                <input className="" id="image" type="file" onChange={e => convert2base64(e)} />
                <button className="btn btn-success" onClick={handleSubmit}>submit</button>
            </div>
            <br />
            <br />
            <br />


            <Container>
                <Row>
                    {projects.map((item) => (
                        <Col xs={12} md={6} lg={3} className="logoBox" key={item.name}>
                            <img width="120px" height="120px" src={item.images} alt="" />
                            <button className="btn btn-danger m-5" onClick={() => handleDelete(item.id)}>delete</button>
                        </Col>
                    ))}
                </Row>
            </Container>







        </div>
    );
}

export default ProjectPhotos;